import React, { useEffect, useState } from 'react';
import { presenceApi } from '../../api';

const HEARTBEAT_INTERVAL_MS = 15000;

function getClientId() {
  const key = 'aac_presence_client_id';
  let value = window.localStorage.getItem(key);
  if (!value) {
    value = window.crypto?.randomUUID?.() || `browser-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    window.localStorage.setItem(key, value);
  }
  return value;
}

export default function OnlinePresencePill() {
  const [total, setTotal] = useState(null);

  useEffect(() => {
    let active = true;
    const clientId = getClientId();

    const sendHeartbeat = async () => {
      try {
        const response = await presenceApi.heartbeat('audit-pro', clientId);
        if (active) setTotal(Number(response.data?.total || 0));
      } catch {
        if (active) setTotal((current) => current);
      }
    };

    sendHeartbeat();
    const timer = window.setInterval(sendHeartbeat, HEARTBEAT_INTERVAL_MS);
    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') sendHeartbeat();
    };
    document.addEventListener('visibilitychange', onVisibilityChange);
    return () => {
      active = false;
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, []);

  // Heartbeat нужен для контроля нагрузки двух приложений, но обезличенный
  // счётчик без списка пользователей не помогает в работе и перегружает шапку.
  // Оставляем сбор технической метрики, не показывая её как действие.
  return <span className="presence-heartbeat-only" data-online-total={total ?? ''} aria-hidden="true" />;
}
